module.exports = "<span class=\"show-page\">\n  Showing {{ getMin() }}-{{ getMax() }} of {{ count }} results\n</span>"